import type { ConfigurationOperation } from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'
import { useCallback } from 'react'

import { useConfigurationContext } from '../../context/configurationContext'
import { stringToDateTimeNullSafe } from '../../uiModels/helpers'
import { isDateActive } from './helpers'

type Props<T extends ConfigurationOperation> = {
  operationInterval: Parameters<typeof isDateActive<T>>[0]['operationInterval']
}

export const useIsViewDateActiveForOperation = <
  T extends ConfigurationOperation,
>({
  operationInterval,
}: Props<T>) => {
  const { viewAt } = useConfigurationContext()

  return useCallback(
    (fromDate: Optional<string>, operations: Optional<T[]>) =>
      isDateActive({
        forInterval: {
          from: stringToDateTimeNullSafe(fromDate, Number.NEGATIVE_INFINITY),
        },
        operations,
        operationInterval,
        viewDate: viewAt,
      }),
    [operationInterval, viewAt],
  )
}
